import { addPermissionsToRoute } from '@qsrsoft/myq-core';

const routes = {
  name: 'Business Unit',
  icon: 'mdi-store-outline',
  path: '/reports/mcd/businessUnit/',
  children: [
    {
      path: '/reports/mcd/businessUnit/consolidatedSalesBu',
      name: 'BU Consolidated Sales',
      meta: { id: 'reports-buConsolidatedSales' },
      component: () =>
        import('@/views/mcd/businessUnit/consolidatedSalesBU.vue'),
      ...addPermissionsToRoute(['buRank']),
    },
    // quicksight for BU team
    {
      path: '/businessUnitBI',
      name: 'Business Unit BI',
      meta: { id: 'bu-dashboard' },
      component: () => import('./quickSight/QuickSightDashboard.vue'),
      ...addPermissionsToRoute(['bu_quicksight_access']),
    },
    {
      path: '/businessUnitBI/customRequestForm',
      name: 'Custom Request Form',
      meta: { id: 'bu-reports' },
      component: () => import('./quickSight/CustomRequestForm.vue'),
      ...addPermissionsToRoute(['bu_quicksight_access']),
    },
    {
      path: '/reports/mcd/businessUnit/voiceRankings',
      name: 'Voice Rankings',
      meta: { id: 'reports-voiceRankings' },
      component: () => import('@/views/mcd/businessUnit/VoiceRankings.vue'),
      ...addPermissionsToRoute(['buRank']),
    },
  ],
};

export default routes;
